import {
  FormValidations,
} from "features/shared/forms/hooks/useForm";
import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";

export const advanceReasonValidations = (): FormValidations => {
  return {
    reason: {
      required: true,
      type: "Pattern",
      regex: /^(.|\s){1,500}$/,
      message: "advanceReasonValidation.reason",
    } as PatternValidatonRule,
  };
};
